/*
 * CUSTOM WEAVE CODE: two-step sign up (snippets/newsletter-form.liquid).
 *
 * Step 1, email: collected on the page only when SMS is enabled; nothing is
 * posted yet.
 * Step 2, mobile (optional, SMS markets only): "Add" posts the email and mobile
 * to the market's Mailchimp audience, which records SMS consent. Shopify's
 * storefront form cannot record SMS consent.
 * Then the Shopify customer form is submitted once, normally, which records
 * email consent ("accepts marketing") and reloads onto the confirmation.
 *
 * Step 2 resolves on: Add, No thanks, closing the popup, or 15 seconds with no
 * activity in the mobile field.
 *
 * Why the Shopify post is a single, normal submit at the end:
 * - Shopify's bot protection listens for submit events on customer forms at the
 *   document level and re-submits the form itself. Any submit event it sees is
 *   a page reload. So step 1 stops the event before it reaches the document,
 *   and only the final submit is allowed through.
 * - Mailchimp receives the mobile before the Shopify to Mailchimp sync creates
 *   the contact. A Mailchimp form post for an email that is already subscribed
 *   does not update it, so posting Shopify first would drop the mobile.
 *
 * Spam protection (Shopify's invisible hCaptcha) still applies. Its check is
 * run on the step 1 click, while the email form is on screen and the visitor
 * has just interacted, as it was before step 2 existed. Run later, after step 2
 * with no click (Add after Mailchimp replies, or the idle timeout), it sent
 * visitors to Shopify's "I am human" page. The token is valid for two minutes;
 * past that, the final submit falls back to Shopify's own check.
 *
 * Markets without SMS: the form submits normally on step 1.
 */
(function () {
  'use strict';

  if (window.WeaveSignupLoaded) return;
  window.WeaveSignupLoaded = true;

  var SIGNED_UP_KEY = 'weaveSignedUp';
  var ORIGIN_KEY = 'weaveSignupForm';
  var IDLE_MS = 15000;
  var TOKEN_MS = 100000; // hCaptcha tokens expire after 120s

  function store(storage, key, value) {
    try {
      if (value === null) { window[storage].removeItem(key); } else { window[storage].setItem(key, value); }
    } catch (e) {}
  }

  function read(storage, key) {
    try { return window[storage].getItem(key); } catch (e) { return null; }
  }

  function Signup(root) {
    this.root = root;
    this.formId = root.dataset.formId;
    this.form = document.getElementById(this.formId);
    this.email = this.form && this.form.querySelector('input[type="email"]');
    this.sms = root.dataset.sms === 'true';
    this.pending = false;    // email collected, Shopify not yet submitted
    this.releasing = false;  // the one submit that may reach Shopify
    this.idleTimer = null;
    this.token = null;       // spam check passed on the step 1 click
    this.tokenAt = 0;
    this.tokenPromise = null;

    if (!this.form || !this.email) return;

    // Back from the Shopify post: show the confirmation on the form that was used.
    if (root.querySelector('[data-weave-posted]')) {
      var origin = read('sessionStorage', ORIGIN_KEY);
      if (!origin || origin === this.formId) {
        this.finish();
        return;
      }
    }

    this.form.addEventListener('submit', this.onSubmit.bind(this));

    if (!this.sms) return;

    this.mobileForm = root.querySelector('.weave-signup__mobile');
    this.mobile = root.querySelector('input[type="tel"]');
    this.error = root.querySelector('[data-weave-error]');
    this.mobileForm.addEventListener('submit', this.onMobile.bind(this));
    root.querySelector('[data-weave-skip]').addEventListener('click', this.resolve.bind(this));

    var restart = this.startIdle.bind(this);
    ['input', 'focus', 'keydown'].forEach(function (type) {
      this.mobile.addEventListener(type, restart);
    }.bind(this));

    // Never lose the email if the visitor leaves during step 2.
    window.addEventListener('pagehide', this.beacon.bind(this));

    var modal = root.closest('.modal');
    if (modal) {
      modal.querySelectorAll('.js-modal-close').forEach(function (btn) {
        btn.addEventListener('click', function () { if (this.pending) this.resolve(); }.bind(this));
      }.bind(this));
    }
  }

  Signup.prototype.show = function (step) {
    this.root.querySelectorAll('[data-step]').forEach(function (el) {
      el.hidden = el.dataset.step !== step;
    });
    var popup = this.root.closest('.weave-popup');
    if (popup) popup.classList.toggle('is-signup-done', step === 'done');
    if (step === 'mobile' && this.mobile) this.mobile.focus();
  };

  Signup.prototype.onSubmit = function (evt) {
    store('sessionStorage', ORIGIN_KEY, this.formId);
    if (this.releasing || !this.sms) return; // let Shopify handle it

    // Step 1 with SMS: keep this submit away from Shopify's handlers entirely.
    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (!this.email.checkValidity()) {
      this.email.reportValidity();
      return;
    }
    this.pending = true;
    this.checkSpam();
    this.show('mobile');
    this.startIdle();
  };

  // Run Shopify's invisible hCaptcha now, on the visitor's click.
  Signup.prototype.checkSpam = function () {
    var frame = this.form.querySelector('.h-captcha iframe[data-hcaptcha-widget-id]');
    if (!window.hcaptcha || !frame) return; // not bound yet: the final submit runs it
    var self = this;
    this.tokenPromise = window.hcaptcha.execute(frame.getAttribute('data-hcaptcha-widget-id'), { async: true })
      .then(function (res) {
        self.token = res && res.response;
        self.tokenAt = Date.now();
      })
      .catch(function (err) { console.warn('[weave-signup] spam check:', err); });
  };

  // Shopify's hCaptcha script tags every protected post with a form_key and
  // keeps a copy of the fields in sessionStorage under it (used to refill the
  // form after a challenge). Without it Shopify rejects the post as "invalid
  // parameters". Same format as Shopify's script.
  Signup.prototype.addFormKey = function () {
    var key = Array.from(Array(32), function () { return Math.random().toString(36)[2]; }).join('');
    var input = this.form.elements.form_key;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'form_key';
      this.form.appendChild(input);
    }
    input.value = key;
    var skip = ['recaptcha-v3-token', 'g-recaptcha-response', 'h-captcha-response', 'password', 'form_key'];
    var data = {};
    new FormData(this.form).forEach(function (value, name) {
      if (skip.indexOf(name) === -1) data[name] = value;
    });
    var saved = {};
    saved.__shopify_v = 1;
    saved.action = this.form.action;
    saved.data = data;
    store('sessionStorage', key, JSON.stringify(saved));
  };

  // Post with the token from the step 1 click. A native submit() fires no
  // submit event, so Shopify's handlers do not run the check a second time.
  Signup.prototype.submitWithToken = function () {
    if (!this.token || Date.now() - this.tokenAt > TOKEN_MS) return false;
    var field = this.form.elements['h-captcha-response'];
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'h-captcha-response';
      this.form.appendChild(field);
    }
    field.value = this.token;
    this.addFormKey();
    HTMLFormElement.prototype.submit.call(this.form);
    return true;
  };

  Signup.prototype.startIdle = function () {
    clearTimeout(this.idleTimer);
    if (!this.pending) return;
    this.idleTimer = setTimeout(function () {
      // Leave a half-typed number alone while the field still has focus.
      if (document.activeElement === this.mobile && this.mobile.value.trim()) {
        this.startIdle();
        return;
      }
      this.resolve();
    }.bind(this), IDLE_MS);
  };

  // AU mobiles: 04xx xxx xxx, 4xx xxx xxx or +61 4xx xxx xxx -> +614xxxxxxxx
  Signup.prototype.normaliseMobile = function (raw) {
    var prefix = (this.root.dataset.smsPrefix || '+61').replace(/\D/g, '');
    var digits = String(raw || '').replace(/\D/g, '');
    if (digits.indexOf(prefix) === 0) digits = digits.slice(prefix.length);
    if (digits.charAt(0) === '0') digits = digits.slice(1);
    if (!/^4\d{8}$/.test(digits)) return null;
    return '+' + prefix + digits;
  };

  Signup.prototype.onMobile = function (evt) {
    evt.preventDefault();
    var number = this.normaliseMobile(this.mobile.value);
    if (!number) {
      this.error.hidden = false;
      this.mobile.setAttribute('aria-invalid', 'true');
      this.mobile.focus();
      this.startIdle();
      return;
    }
    this.error.hidden = true;
    this.mobile.removeAttribute('aria-invalid');
    clearTimeout(this.idleTimer);
    this.root.classList.add('is-loading');
    this.postMailchimp(number, this.resolve.bind(this));
  };

  // Mailchimp's form endpoint, JSONP variant, so no new tab opens.
  Signup.prototype.postMailchimp = function (number, done) {
    var url = (this.root.dataset.mcUrl || '').replace(/&amp;/g, '&').replace('/subscribe/post?', '/subscribe/post-json?');
    var u = (url.match(/[?&]u=([^&]+)/) || [])[1];
    var id = (url.match(/[?&]id=([^&]+)/) || [])[1];
    var cb = 'weaveMc' + Date.now();
    var finished = false;
    var script = document.createElement('script');

    var complete = function (result) {
      if (finished) return;
      finished = true;
      if (!result || result.result !== 'success') {
        // Logged, not shown: the email still goes to Shopify regardless.
        console.warn('[weave-signup] Mailchimp:', result && result.msg);
      } else {
        console.info('[weave-signup] Mailchimp:', result.msg);
      }
      try { delete window[cb]; } catch (e) { window[cb] = undefined; }
      script.remove();
      done();
    };

    window[cb] = complete;
    var params = [
      'EMAIL=' + encodeURIComponent(this.email.value.trim()),
      (this.root.dataset.smsField || 'MERGE6') + '=' + encodeURIComponent(number),
      'selected_country_code=' + encodeURIComponent(this.root.dataset.smsCountry || 'AU'),
      'b_' + u + '_' + id + '=',
      'c=' + cb
    ];
    script.src = url + (url.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    script.onerror = function () { complete({ result: 'error', msg: 'request failed' }); };
    document.head.appendChild(script);
    setTimeout(function () { complete({ result: 'error', msg: 'timed out' }); }, 8000);
  };

  // The single Shopify submit. Goes through Shopify's own handlers (bot
  // protection included) and reloads onto the confirmation.
  Signup.prototype.resolve = function () {
    if (!this.pending) return;
    this.pending = false;
    clearTimeout(this.idleTimer);
    this.root.classList.add('is-loading');
    this.releasing = true;
    store('sessionStorage', ORIGIN_KEY, this.formId);

    var self = this;
    var fallback = function () {
      if (typeof self.form.requestSubmit === 'function') {
        self.form.requestSubmit();
      } else {
        self.form.submit();
      }
    };
    if (!this.tokenPromise) { fallback(); return; }
    // The check may still be running if step 2 was skipped straight away.
    var done = false;
    var go = function () {
      if (done) return;
      done = true;
      if (!self.submitWithToken()) fallback();
    };
    this.tokenPromise.then(go);
    setTimeout(go, 8000);
  };

  // Visitor left during step 2: send the email anyway.
  Signup.prototype.beacon = function () {
    if (!this.pending || !navigator.sendBeacon) return;
    this.pending = false;
    navigator.sendBeacon(this.form.action, new FormData(this.form));
    store('localStorage', SIGNED_UP_KEY, '1');
  };

  Signup.prototype.finish = function () {
    this.pending = false;
    this.root.classList.remove('is-loading');
    store('localStorage', SIGNED_UP_KEY, '1');
    store('sessionStorage', ORIGIN_KEY, null);
    this.show('done');
  };

  function init() {
    document.querySelectorAll('[data-weave-signup]').forEach(function (root) {
      if (!root.weaveSignup) root.weaveSignup = new Signup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders sections.
  document.addEventListener('shopify:section:load', init);
})();
